(function () {
  'use strict';

  var CACHE_KEY = 'stenve_currency_v1';
  var CACHE_HOURS = 12;
  var MARKUP = 1.24; // 24% markup on converted price
  var RESCAN_DEBOUNCE_MS = 200;
  var OBSERVER_IDLE_MS = 3000; // stop watching DOM after this long with no changes

  // Country -> target currency. Anything not in this map (except PK) falls back to USD.
  var COUNTRY_CURRENCY_MAP = {
    US: 'USD', CA: 'USD', AU: 'USD', NZ: 'USD', SG: 'USD',
    GB: 'GBP',
    AE: 'AED', SA: 'AED', QA: 'AED', KW: 'AED', BH: 'AED', OM: 'AED',
    DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR',
    AT: 'EUR', IE: 'EUR', PT: 'EUR', FI: 'EUR', GR: 'EUR', LU: 'EUR'
  };

  var CURRENCY_SYMBOL = { USD: '$', GBP: '£', EUR: '€', AED: 'AED ' };

  // Matches Shopify money_format output for this store, e.g. "Rs.3,500.00 PKR" or "Rs.3,500"
  var PKR_PRICE_REGEX = /Rs\.?\s?([\d,]+(?:\.\d+)?)(?:\s?PKR)?/g;

  // Only elements matching this selector are watched for changes, instead of the whole body.
  var PRICE_CONTAINER_SELECTOR =
    '#MainContent, .cart-drawer, cart-drawer, #CartDrawer, .cart-notification, #shopify-section-cart-notification, .price, [class*="price"]';

  function getCached() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data.timestamp || Date.now() - data.timestamp > CACHE_HOURS * 3600 * 1000) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function setCached(data) {
    try {
      data.timestamp = Date.now();
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch (e) {
      /* ignore (private browsing, etc.) */
    }
  }

  function detectCountry() {
    return fetch('https://ipwho.is/', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d && d.success !== false && d.country_code ? d.country_code : null; })
      .catch(function () { return null; });
  }

  function fetchRates() {
    return fetch('https://open.er-api.com/v6/latest/PKR', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d && d.rates ? d.rates : null; })
      .catch(function () { return null; });
  }

  function formatConverted(pkrAmount, currency, rate) {
    var converted = pkrAmount * rate * MARKUP;
    var symbol = CURRENCY_SYMBOL[currency] || currency + ' ';
    return symbol + converted.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function insertDisclaimer(currency) {
    if (document.getElementById('stenve-currency-disclaimer')) return;
    var bar = document.createElement('div');
    bar.id = 'stenve-currency-disclaimer';
    bar.setAttribute('role', 'note');
    bar.style.cssText =
      'background:#f4f4f2;color:#333;font-size:12px;text-align:center;padding:8px 12px;line-height:1.4;';
    bar.textContent =
      'Prices shown in ' + currency + ' for your convenience. You will be charged in PKR (Pakistani Rupees) at checkout.';
    var main = document.getElementById('MainContent');
    if (main && main.parentNode) {
      main.parentNode.insertBefore(bar, main);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }

  function convertAndDisplay(currency, rates) {
    if (!currency || currency === 'PKR' || !rates || !rates[currency]) return;
    var rate = rates[currency];

    function convertText(text) {
      return text.replace(PKR_PRICE_REGEX, function (match, numStr) {
        var pkrAmount = parseFloat(numStr.replace(/,/g, ''));
        if (isNaN(pkrAmount)) return match;
        return formatConverted(pkrAmount, currency, rate);
      });
    }

    function processElement(el) {
      if (el.dataset && el.dataset.currencyConverted === 'true') return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
      var textNodes = [];
      var node;
      while ((node = walker.nextNode())) {
        if (PKR_PRICE_REGEX.test(node.nodeValue)) {
          textNodes.push(node);
        }
        PKR_PRICE_REGEX.lastIndex = 0;
      }
      textNodes.forEach(function (tn) {
        tn.nodeValue = convertText(tn.nodeValue);
      });
      if (el.dataset) el.dataset.currencyConverted = 'true';
    }

    function scanAndConvert() {
      var priceEls = document.querySelectorAll('.price, .price-item, .money, [class*="price"]');
      priceEls.forEach(processElement);
      if (priceEls.length) insertDisclaimer(currency);
    }

    scanAndConvert();

    // Only watch known price-bearing containers (main content, cart drawer, cart
    // notification) instead of the entire document body, and stop watching once
    // the page has been idle for a while so we're not scanning forever.
    var watchTargets = document.querySelectorAll(PRICE_CONTAINER_SELECTOR);
    if (!watchTargets.length) return;

    var rescanTimer = null;
    var idleTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(rescanTimer);
      rescanTimer = setTimeout(scanAndConvert, RESCAN_DEBOUNCE_MS);

      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        observer.disconnect();
      }, OBSERVER_IDLE_MS);
    });

    watchTargets.forEach(function (target) {
      observer.observe(target, { childList: true, subtree: true });
    });

    idleTimer = setTimeout(function () {
      observer.disconnect();
    }, OBSERVER_IDLE_MS);
  }

  function init() {
    var cached = getCached();
    if (cached && cached.currency && cached.rates) {
      convertAndDisplay(cached.currency, cached.rates);
      return;
    }

    // Kick off country detection and exchange-rate fetch in parallel instead of
    // waiting for country detection to finish before starting the rates request.
    var countryPromise = detectCountry();
    var ratesPromise = fetchRates();

    countryPromise.then(function (countryCode) {
      if (!countryCode || countryCode === 'PK') return;

      var currency = COUNTRY_CURRENCY_MAP[countryCode] || 'USD';

      ratesPromise.then(function (rates) {
        if (!rates) return;
        setCached({ currency: currency, rates: rates });
        convertAndDisplay(currency, rates);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
